import { AppTagEntityModel } from "src/store/models/entity/appTag/entity";
import { AppTagHelperModel } from "src/store/models/entity/appTag/helper";

export const encooAppTagModels = {
  entity: AppTagEntityModel,
  helper: AppTagHelperModel,
};
